import { render, staticRenderFns } from "./sizeModel_page.vue?vue&type=template&id=00b1aabe&scoped=true"
import script from "./sizeModel_page.vue?vue&type=script&lang=js"
export * from "./sizeModel_page.vue?vue&type=script&lang=js"
import style0 from "./sizeModel_page.vue?vue&type=style&index=0&id=00b1aabe&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00b1aabe",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/riverlei/project/java/bgyy-project/front-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('00b1aabe')) {
      api.createRecord('00b1aabe', component.options)
    } else {
      api.reload('00b1aabe', component.options)
    }
    module.hot.accept("./sizeModel_page.vue?vue&type=template&id=00b1aabe&scoped=true", function () {
      api.rerender('00b1aabe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/logistics_hongde/sizeModel_page.vue"
export default component.exports